import React from "react";
import Icon from "components/AppIcon";

const SubscriptionSection = ({ formData, errors, isArabic, onInputChange }) => {
  const packageOptions = [
    {
      value: "monthly",
      label: isArabic ? "شهري" : "Monthly",
      duration: "1 month",
    },
    {
      value: "quarterly",
      label: isArabic ? "ربع سنوي" : "Quarterly",
      duration: "3 months",
    },
    {
      value: "semi-annual",
      label: isArabic ? "نصف سنوي" : "Semi-Annual",
      duration: "6 months",
    },
    {
      value: "annual",
      label: isArabic ? "سنوي" : "Annual",
      duration: "12 months",
    },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString(isArabic ? "ar-SA" : "en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="mb-8">
      <div className="flex items-center mb-6">
        <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
          <Icon name="Calendar" size={20} color="#7c3aed" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">
          {isArabic ? "إدارة الاشتراك" : "Subscription Management"}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Package Type 
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? 'نوع الباقة' : 'Package Type'}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {packageOptions.map((option) => (
              <label
                key={option.value}
                className={`relative flex flex-col items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
                  formData.packageType === option.value
                    ? 'border-green-500 bg-green-50' :'border-gray-200 hover:border-green-300'
                }`}
              >
                <input
                  type="radio"
                  name="packageType"
                  value={option.value}
                  checked={formData.packageType === option.value}
                  onChange={(e) => onInputChange('packageType', e.target.value)}
                  className="sr-only"
                />
                <div className={`w-4 h-4 rounded-full border-2 mb-2 ${
                  formData.packageType === option.value
                    ? 'border-green-500 bg-green-500' :'border-gray-300'
                }`}>
                  {formData.packageType === option.value && (
                    <div className="w-2 h-2 bg-white rounded-full mx-auto mt-0.5"></div>
                  )}
                </div>
                <span className="text-sm font-medium text-gray-900 text-center">
                  {option.label}
                </span>
                <span className="text-xs text-gray-500 text-center mt-1">
                  {option.duration}
                </span>
              </label>
            ))}
          </div>
        </div>*/}

        {/* Start Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? "تاريخ بداية الاشتراك" : "Subscription Start Date"}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <input
            type="date"
            value={formData.start_date}
            onChange={(e) => onInputChange("start_date", e.target.value)}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
              errors.start_date ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.start_date && (
            <p className="mt-1 text-sm text-red-600 flex items-center">
              <Icon name="AlertCircle" size={16} className="mr-1" />
              {errors.start_date}
            </p>
          )}
          {formData.start_date && (
            <p className="mt-1 text-xs text-gray-500">
              {isArabic ? "التاريخ المحدد:" : "Selected date:"}{" "}
              {formatDate(formData.start_date)}
            </p>
          )}
        </div>

        {/* End Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? "تاريخ انتهاء الاشتراك" : "Subscription End Date"}
          </label>

          <input
            type="date"
            value={formData.end_date}
            onChange={(e) => onInputChange("end_date", e.target.value)}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
              errors.start_date ? "border-red-500" : "border-gray-300"
            }`}
          />

          {formData.end_date && (
            <p className="mt-1 text-xs text-green-600">
              {isArabic ? "تاريخ الانتهاء:" : "End date:"}{" "}
              {formatDate(formData.end_date)}
            </p>
          )}
        </div>
      </div>

      {/* Subscription Summary */}
      {formData.start_date && formData.end_date && (
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center mb-2">
            <Icon name="Info" size={16} color="#16a34a" className="mr-2" />
            <span className="text-sm font-medium text-green-800">
              {isArabic ? "ملخص الاشتراك" : "Subscription Summary"}
            </span>
          </div>
          <div className="text-sm text-green-700">
          
            <p>
              {isArabic
                ? `المدة: من ${formatDate(
                    formData.start_date
                  )} إلى ${formatDate(formData.end_date)}`
                : `Duration: ${formatDate(formData.start_date)} to ${formatDate(
                    formData.end_date
                  )}`}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionSection;
